import ReactPDF, {
  Document,
  Image,
  Font,
  Page,
  StyleSheet,
  Text,
  View,
  PDFViewer,
} from "@react-pdf/renderer";
import { useEffect, useState } from "react";
import moment from "moment";
import { styles } from "../style";
import ItemDetails from "../../CommonPdfComponents/ItemDetails";
import BillFromAndLogo from "./BillFromAndLogo";
import PaymentDetails from "../../CommonPdfComponents/PaymentDetails";
import {
  SinglePdfHeaderType,
  tableHeaders
} from "../constant";

type AppProps = {
  downloadRevenuesData: any;
  currencySign: string | undefined;
  currencyShortForm: string | undefined;
};

const GenericRasPolypackWithoutNa = ({
  downloadRevenuesData,
  currencySign,
  currencyShortForm,
}: AppProps) => {
  const [data, setData] = useState<any>({});
  const [finalTableHeader, setFinalTableHeader] = useState<
    SinglePdfHeaderType[]
  >([{ name: "", column_value: "" }]);
  const [isIgstPresent, setIsIgstPresent] = useState<boolean>(false);
  const [isGstPresent, setIsGstPresent] = useState<boolean>(false);
  const [isSkuPresent, setIsSkuPresent] = useState<boolean>(false);

  useEffect(() => {
    if (downloadRevenuesData) {
      let checked = checkForGst(downloadRevenuesData?.item_details);
      if (!checked?.gst) {
        let newTableHeader = tableHeaders?.filter(item => item.column_value !== "gst_percentage" && item.column_value !== "cgst_amount" && item.column_value !== "igst_amount" && item.column_value !== "sgst_amount");
        setFinalTableHeader([...newTableHeader])
      }

      if (!checked?.isSquPresent && checked?.gst) {
        if (checked?.isIgstPresent) {
          let newTableHeader = tableHeaders?.filter(item => item.column_value !== "sku_code" && item.column_value !== "cgst_amount" && item.column_value !== "sgst_amount");
          setFinalTableHeader([...newTableHeader])
        }
        else if (!checked?.isIgstPresent) {
          let newTableHeader = tableHeaders?.filter(item => item.column_value !== "sku_code" && item.column_value !== "igst_amount");
          setFinalTableHeader([...newTableHeader])
        }
      }

      if (checked?.gst && checked?.isSquPresent) {
        if (checked?.isIgstPresent) {
          let newTableHeader = tableHeaders?.filter(item => item.column_value !== "cgst_amount" && item.column_value !== "sgst_amount");
          setFinalTableHeader([...newTableHeader])
        }
        else if (!checked?.isIgstPresent) {
          let newTableHeader = tableHeaders?.filter(item => item.column_value !== "igst_amount");
          setFinalTableHeader([...newTableHeader])
        }
      }

      if (!checked?.gst && !checked?.isSquPresent) {
        let newTableHeader = tableHeaders?.filter(item => item.column_value !== "sku_code" && item.column_value !== "gst_percentage" && item.column_value !== "cgst_amount" && item.column_value !== "igst_amount" && item.column_value !== "sgst_amount");
        setFinalTableHeader([...newTableHeader])
      }

      if (checked?.isSquPresent && !checked?.gst) {
        if (checked?.isIgstPresent) {
          let newTableHeader = tableHeaders?.filter(item => item.column_value !== "gst_percentage" && item.column_value !== "cgst_amount" && item.column_value !== "igst_amount" && item.column_value !== "sgst_amount");
          setFinalTableHeader([...newTableHeader])
        }
      }
      setData({ ...downloadRevenuesData });
    }
  }, [downloadRevenuesData]);

  const checkForGst = (data: any) => {
    let isSquPresent = false;
    let isIgstPresent = false;
    let gst = false;

    data?.map((singleItem: any) => {
      if (!!singleItem?.sku_code) {
        isSquPresent = true;
      }
      if (+singleItem?.igst_amount > 0) {
        isIgstPresent = true;
      }
      if (+singleItem?.gst_percentage > 0) {
        gst = true;
      }
    });

    return { isSquPresent, isIgstPresent, gst };
  };

  return (
    <Document>
      <Page size={"A4"} style={styles.body}>
        {/* bill from and logo  */}
        <BillFromAndLogo downloadRevenuesData={data} />

        {/* Item Details  */}
        <ItemDetails
          downloadRevenuesData={data}
          tableHeaders={finalTableHeader}
          isIgstPresent={isIgstPresent}
          currencySign={currencySign}
          isGstPresent={isGstPresent}
          currencyShortForm={currencyShortForm}
        />

        {/* payment Details  */}
        <View style={{ marginTop: "25px", marginRight: "4px" }}>
          <PaymentDetails downloadRevenuesData={data} />
        </View>

        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />

        <Text style={styles.time} fixed>
          document generated at{" "}
          {`${moment(new Date()).format("DD-MM-YYYY HH:mm:ss")}`}
        </Text>
      </Page>
    </Document>
  );
};

export default GenericRasPolypackWithoutNa;